import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    
    
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import React from "react";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import colorPallete from "@DSG/MobiusOverrides/styles/variables";

export interface RequestPasswordResetConfirmationPageStyles {
    page?: MobiusPageProps;
}

export const requestPasswordResetConfirmationPageStyles: RequestPasswordResetConfirmationPageStyles = {
    page: {
        css: css`
            padding-left: 16px;
            padding-right: 16px;
            [data-test-selector="PageTitle"] {
                margin-bottom: 24px;
            }
            p {
                color: ${colorPallete.grey800};
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: 24px;
                        padding-right: 24px;
                       
                    `,
                    css`
                        padding-left: 80px;
                        padding-right: 80px;
                    `,
                ],
                "min",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-bottom: 48px !important;
                    `
                ],
                "max",
            )}
        `
    },
}

const styles = requestPasswordResetConfirmationPageStyles;

const RequestPasswordResetConfirmationPage = ({ id }: PageProps) => (
    <Page {...styles.page}>
        <Zone contentId={id} zoneName="Content"></Zone>
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: RequestPasswordResetConfirmationPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [        
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
